import Vue from 'vue'

export default {
  getHome: (empId) => Vue.http.get(`cliente/portal/get/home/${empId}`).then(res => res.json()),

  getStatusDetalhe: (empId, statusId) => Vue.http.get(`cliente/portal/get/statusobra/${empId}/${statusId}`).then(res => res.json()),

  getStatus: (empId) => Vue.http.get(`cliente/portal/get/statusobra-referencias/${empId}`).then(res => res.json()),

  getDocumentos: (empId, unidade) => Vue.http.get(`cliente/portal/get/documentos/${empId}/${unidade}/geral`).then(res => res.json()),

  getManual: (empId, unidade) => Vue.http.get(`cliente/portal/get/manual/${empId}/${unidade}`).then(res => res.json()),

  getComunicados: (codigo, empId) => Vue.http.get(`cliente/portal/get/comunicados/${codigo}/${empId}`).then(res => res.json()),

  getPersonalizacao: (empId) => Vue.http.get(`cliente/portal/get/personalizacao/${empId}`).then(res => res.json()),

  getPersonalizacaoAgendamentos: (empId, codigo, unidade) => Vue.http.get(`cliente/portal/get/agendamentos-cliente/${empId}/${codigo}/${unidade}`).then(res => res.json()),

  agendaPersonalizacao: (obj) => Vue.http.post(`cliente/portal/post/agendamento-personalizacao`, obj).then(res => res.json()),

  getPlantas: (empId) => Vue.http.get(`cliente/portal/get/plantas/${empId}`).then(res => res.json()),

  getForum: (empId) => Vue.http.get(`cliente/portal/get/forum/${empId}`).then(res => res.json()),

  postForum: (obj) => Vue.http.post(`cliente/portal/post/forum`, obj).then(res => res.json()),

  getExtrato: (codigo) => Vue.http.get(`cliente/portal/get/extrato/${codigo}`).then(res => res.json()),

  getBoleto: (contrato, parcela) => Vue.http.get(`cliente/portal/get/boleto/pdf/${contrato}/${parcela}`).then(res => res.json()),

  getGuia: () => Vue.http.get(`cliente/portal/get/guiafinanceiro`).then(res => res.json()),

  getInfoMenu: (empId, codigo) => Vue.http.get(`cliente/portal/get/info-menu/${empId}/${codigo}`).then(res => res.json()),

  trocaSenha: (obj) => Vue.http.post(`cliente/portal/post/alterar-senha`, obj).then(res => res.json()),

  enviaMensagem: (obj) => Vue.http.post(`cliente/portal/post/mensagem`, obj).then(res => res.json()),

  insertLog: (obj) => Vue.http.post(`cliente/auth/insertlog`, obj).then(res => res.json()),

  getEmp: (id) => Vue.http.get(`empreendimentos/cadastro/findById/${id}`).then(res => res.json()),

  getFicha: (id) => Vue.http.get(`cliente/portal/get/itens-ficha/${id}`).then(res => res.json()),

  getGuiacliente: () => Vue.http.get(`cliente/guia-cliente`).then(res => res.json()),

  getBoletoAntecipacao: (contrato, parcela) => Vue.http.get(`cliente/portal/get/boleto/antecipacao/${contrato}/${parcela}`).then(res => res.json()),

  simulaAntecipacao: (obj) => Vue.http.post(`cliente/portal/simular-antecipacao`, obj).then(res => res.json()),

  getAnosIRPF: c => Vue.http.get(`cliente/portal/get/informe/datas/${c}`).then(res => res.json()),

  getIRPF: (c, y) => Vue.http.get(`cliente/portal/get/informe/pdf/${c}/${y}`).then(res => res.json()),

  getIRPFAnoAnterior: (c) => Vue.http.get(`cliente/portal/get/informe/ano-anterior/${c}`).then(res => res.json()),

  getFAQ: () => Vue.http.get(`cliente/portal/get/faq`).then(res => res.json()),

  getMenu: () => Vue.http.get(`cliente/menu`).then(res => res.json())
  // // Uploadportal/get/informe/datas
  // upload: (file, tipo, empId, bloco) => {
  //   const formData = new FormData();
  //   formData.append('file', file, file.name)

  //   return Vue.http.post(`empreendimentos/blocos/upload/${tipo}/${empId}/${bloco}`, formData).then(res => res.json())
  //   // /empreendimentos/blocos/upload/{tipo}/{id}/{bloco}
  //   // tipo = desktop / mobile
  //   // id = id empreendimento
  //   // bloco = highlights / arquitetos / etc
  // }, // upload()
}
